import { kebabCase } from 'lodash';
import styled from 'styled-components';

type AttrProps = {
  active?: boolean;
  activeSuffix?: string;
  className?: string;
  name: string;
};

type Props = {
  rotate?: number;
  flipY?: boolean;
} & AttrProps;

const iconPrefix = 'ch-c-icon__';

const Icon = styled.i.attrs<Props>(({ active = false, activeSuffix = 'active', className = '', name }: AttrProps) => ({
  className: `${iconPrefix}${kebabCase(name)}${active ? `--${activeSuffix}` : ''} ${className}`,
}))<Props>`
  display: block;
  flex: none;
  transform: ${({ rotate = 0, flipY = false }) => {
    return [rotate === 0 ? '' : `rotate(${rotate}deg)`, flipY ? 'rotateY(180deg)' : ''].join(' ');
  }};
`;

export default Icon;
